import {Component, Input, OnInit}                                   from "@angular/core";
import {SupportRequest, PermissionType, User, Notification, Ticket} from "../../../models";
import {SessionService}                                             from "../../services/session.service";
import {DataStore}                                                  from "@aws-amplify/datastore";
import {NotificationService}                                        from "../../services/notification.service";

@Component({
    selector: "app-support-chat",
    templateUrl: "./support-chat.component.html",
    styleUrls: ["./support-chat.component.scss"],
})
export class SupportChatComponent implements OnInit {
    messages = [];

    @Input() ticketId: string;

    constructor(public sessionService: SessionService, private notification: NotificationService) {
    }

    async ngOnInit() {
        DataStore.observeQuery(SupportRequest, x => x.ticketId('eq', this.ticketId)).subscribe(val => {
            this.messages = val.items;
            
            this.scrollToLastMessage();
        })

        setTimeout(() => {
            this.scrollToLastMessage();
        }, 1000);
    }

    async sendRequest() {
        const messageNode = document.getElementsByName(
                "msg"
        )[0] as HTMLInputElement;

        if (messageNode.value == "") return false;


        let newMessageObject: any = {
            supportRequestFromUserId: this.sessionService.user.id,
            createdAt: new Date().toISOString(),
            fromId: this.sessionService.user.id,
            message: messageNode.value,
            ticketId: this.ticketId

        };
        if (this.sessionService.user?.permessions == PermissionType.CLIENT) {
            newMessageObject = {
                ...newMessageObject,
                agentId: this.sessionService.user.addedBy,
                clientId: this.sessionService.user.id,

            };

        } else {
            newMessageObject = {
                ...newMessageObject,
                agentId: this.sessionService.user.id,
                clientId: this.messages[0].clientId,
            };


        }

        // this.messages.push(newMessageObject);
        try {
            let m = await DataStore.save(new SupportRequest(newMessageObject));

            if (this.sessionService.user?.permessions == this.sessionService.permissionType.CLIENT) {
                const msg = "Hai ricevuto un nuovo messaggio da " + this.sessionService.user?.name + " " + this.sessionService.user?.lastname;
                await this.notification.notifyAdmin(msg,"/agent-support-chat/"+this.ticketId);

            } else {
                let t = await DataStore.query(Ticket, this.ticketId);
                const msg = "Hai ricevuto un nuovo messaggio alla tua richiesta di supporto";
                await this.notification.notify(t.client?.device_id, msg);
            }

        } catch (e) {
            
        }

        // ...and scroll to bottom
        // this.scrollToLastMessage();

        messageNode.value = "";
    }

    scrollToLastMessage() {
        const scrollerNode = document.querySelector(
                ".ion-page:not(ion-app):not(.ion-page-hidden) .main-dcontent"
        ) as HTMLElement;
        scrollerNode.scrollBy(0, 100000);
    }

    private makeid(length) {
        var result = "";
        var characters =
                "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }
}
